import CancelOrder from "./CancelOrder";
import ContactSupport from "./ContactSupport";
import ReorderAndSupport from "./ReorderAndSupport";
import { STATUS_GROUPS } from "../../../../../../features/orders/orderStatus";

const SummaryFooter = ({ cancellableIds, statusGroup, orderId, refetch }) => {
  if (cancellableIds.length > 0)
    return (
      <>
        <ContactSupport outline={true} />
        <CancelOrder cancellableIds={cancellableIds} refetch={refetch} />
      </>
    );

  if (statusGroup === STATUS_GROUPS.PAST)
    return <ReorderAndSupport orderId={orderId} />;

  return <ContactSupport />;
};

export default SummaryFooter;
